module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"negative":"Alarm","positive":"OK"},"de":{"negative":"Alarm","positive":"OK"},"fr":{"negative":"Alarme","positive":"Ok"},"it":{"negative":"Alarm","positive":"OK"}}')
  delete Component.options._Ctor
}
